/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
@Component({
  templateUrl:'./signInTaskProductEdit.html'
})

export class SignInTaskProductEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location,
    private fileupload:FileUpload
  ){}

  private data:any={
    "badgeId": "",
    "describeEn": "",
    "describeTc": "",
    "id": "",
    "imageEn": "",
    "imageTc": "",
    "titleEn": "",
    "titleTc": "",
    "describeTitleEn": "",
    "describeTitleTc": ""


  }

  private id:number = 0;

  private isCreate:boolean=false;

  public signData = [];
  private imagePath:string='';


  ngOnInit(): void {
    this.getSignData();
    this.getPath();
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });

    if(this.id!=0){
      this.getData();
    }else {
      this.isCreate = true;
    }
  }


//获取下拉列表
  private getSignData():void{
    this.HttpService.getData(API.sign_in_select).then(res=>{
      this.signData= res.data;
    })
  }
//获取全部数据
  private getData():void{
    this.HttpService.getData(API.sign_in_product+'/'+this.id).then(res=>{
      this.data = res.data;
    })
  }


  // 获取图片路径
  private showImageEn:boolean = false;
  private showImageTc:boolean = false;
  private tempPath:string=API.getTemp;
  private upload(name:string){
    let self=this;
    this.fileupload.upload(function (res) {
      let temRes=JSON.parse(res);
      if(temRes.status.code==0){
        switch (name){
          case 'imageEn':self.showImageEn=true;break;
          case 'imageTc':self.showImageTc=true;break;
        }
        self.data[name]=temRes.data.fileName;
      }
    });
  }

  private getPath():void{
    this.HttpService.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        console.log(res.data)
      })
  }

  private submit():void{
    this.HttpService.postData(API.sign_in_product_createOrUpdate,{
      'id':this.id,
      "badgeId":this.data.badgeId,
      "describeEn":this.data.describeEn,
      "describeTc":this.data.describeTc,
      "imageEn": this.data.imageEn,
      "imageTc":this.data.imageTc,
      "titleEn":this.data.titleEn,
      "titleTc": this.data.titleTc,
      "describeTitleEn": this.data.describeTitleEn,
      "describeTitleTc": this.data.describeTitleTc


    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
      }else{
        alert(data.status.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/badge/signInTaskProductEdit.component.ts